<script>
    import HeaderCart from "./HeaderCart";
    import {cartStore} from "../../common/store/cart-store";
    import CartFastContent from "../cart/CartFastContent";

    export default {
        el: '#header-cart-desktop',

        name: "CartFastDesktop",

        extends: HeaderCart,

        components: {
            'cart-fast-content': CartFastContent
        },

        data() {
            return {
                mouseIsOver: false,
            }
        },

        watch: {
            mouseIsOver(newVal) {
                if (newVal) this.fetch();
            },
        },

        methods: {
            onMouseLeave() {
                this.mouseIsOver = false;
                cartStore.hide();
            }
        }
    }
</script>